import React, { useState } from 'react';

import { Col } from 'react-bootstrap';

import BrandFilter from 'components/product_lists/product_list/filters/BrandFilter';
import ManufacturerFilter from 'components/product_lists/product_list/filters/ManufacturerFilter';
import SkuMappingWorkflow from 'components/sku_mapping_workflow/SkuMappingWorkflow';
import { SkuMappingWorkflowTypes } from 'lib/enums/SkuMappingWorkflowEnum';

function SkuMappingWorkflowEnrichBrand() {
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [selectedBrands, setSelectedBrands] = useState([]);

  return (
    <>
      <Col sm={4}>
        <ManufacturerFilter
          selectedValues={selectedManufacturer?.value ? [selectedManufacturer.value] : []}
          updateFilters={(_, option) => setSelectedManufacturer(option)}
          isMultiSelect={false}
        />
      </Col>
      <Col sm={4}>
        <BrandFilter
          selectedValues={selectedBrands || []}
          updateFilters={(_, brandIds) => setSelectedBrands(brandIds)}
          selectedManufacturerId={selectedManufacturer?.value}
        />
      </Col>
      {selectedManufacturer && selectedBrands.length === 1 && (
        <SkuMappingWorkflow
          workflowType={SkuMappingWorkflowTypes.BRAND}
          workflowValue={selectedBrands.join(',')}
        />
      )}
    </>
  );
}

export default SkuMappingWorkflowEnrichBrand;
